import { Injectable } from '@angular/core';
import { Store } from "@ngrx/store";
import { selectConnectedUser, selectIsAcepPartner, selectIsMandataire } from "../../../ngrx/selectors/user.selectors";
import { User } from "../../../core/user/user.types";
import { takeWhile } from "rxjs";
import { FuseNavigationItem } from "../../../../@fuse/components/navigation";
import { NavigationMockApi } from "./api";
import { User_UserProfile } from 'app/modules/models/profile-management/userProfile.type';
import { environment } from 'environments/environment';

@Injectable({
  providedIn: 'root'
})
export class DataService {
  env = environment;
  currentUser: User;
  currentUser$ = this.store.select(selectConnectedUser);
  isAcepPartner$ = this.store.select(selectIsAcepPartner);
  isMandataire$ = this.store.select(selectIsMandataire);
  alive: boolean = true;
  isAcepPartner: boolean = false;
  isMandataire: boolean = false;
  hasSimulationPermission: boolean = false;

  constructor(
    private store: Store) {
    this.currentUser$
      .pipe(takeWhile(() => this.alive))
      .subscribe(res => {
        if (res) {
          this.currentUser = res;
          this.hasSimulationPermission = res.user_UserProfiles?.some((up: any) =>
            up.userProfile?.permissions?.some((perm: any) => perm?.pageRoute.trim().toLowerCase() === 'simulator')
          ) ?? false;
          //this.alive = false;
        }
      })

    this.isAcepPartner$
      .pipe(takeWhile(() => this.alive))
      .subscribe(res => {
        this.isAcepPartner = res;
      })

    this.isMandataire$
      .pipe(takeWhile(() => this.alive))
      .subscribe(res => {
        this.isMandataire = res;
      })
  }

  executeActionBeforeLeavingCustomerDetails(uri): void {
    NavigationMockApi.executeActionBeforeLeavingCustomerDetails(uri);
  }

  isACEPUser() {
    return this.currentUser?.hasEPAccess;
  }

  isSicaUser() {
    return this.currentUser?.hasCrmAccess;
  }

  hasSimulationAccess(): boolean {
    return this.hasSimulationPermission;
  }

  isBothACEPSicaUser() {
    return this.currentUser?.hasEPAccess && this.currentUser?.hasCrmAccess;
  }

  isPartnerSpaceAdmin(): boolean {
    return this.hasTargetRole(
      this.currentUser?.user_UserProfiles,
      'Admin E. Partenaire'
    );
  }

  hasTargetRole(
    user_UserProfiles: User_UserProfile[] | null | undefined,
    targetRole: string | string[]
  ): boolean {
    if (!user_UserProfiles || user_UserProfiles.length === 0) {
      return false;
    }

    const roles = user_UserProfiles
      .map(u => u?.userProfile?.name)
      .filter((name): name is string => !!name); // remove null/undefined

    const targetRoles = Array.isArray(targetRole) ? targetRole : [targetRole];

    const result = roles.some(r => {
      const match = targetRoles.includes(r);
      return match;
    });

    return result;
  }

  shouldShowClassicDossiers(): boolean {
    if (this.hasTargetRole(this.currentUser?.user_UserProfiles, ['Superviseur'])) {
      return localStorage.getItem('supervisorHasEProjetAccess_localstorage') !== 'true';
    }

    return !this.hasTargetRole(this.currentUser?.user_UserProfiles, [
      'Partenaire ACEP Projets',
      'Mandataire Projets',
      'Mandataire administratif Projets'
    ]);
  }

  shouldShowProjectDossiers(): boolean {
    if (this.hasTargetRole(this.currentUser?.user_UserProfiles, ['Superviseur'])) {
      return localStorage.getItem('supervisorHasEProjetAccess_localstorage') === 'true';
    }

    return this.hasTargetRole(this.currentUser?.user_UserProfiles, [
      'Partenaire ACEP Projets',
      'Mandataire Projets',
      'Mandataire administratif Projets'
    ]);
  }





  getDefaultNavigation(): FuseNavigationItem[] {
    return [
      {
        id: 'dashboard',
        title: 'Accueil',
        type: 'basic',
        link: '/dashboard',
        roles: 'Admin',
        //hidden: _ => !this.isACEPUser(),
      },
      {
        id: 'prospects',
        title: 'Clients',
        type: 'basic',
        link: '/prospects',
        roles: 'Admin',
        hidden: _ => !this.isSicaUser(),
      },
      {
        id: 'simulation',
        title: 'Simulation',
        type: 'basic',
        link: '/simulator',
        roles: 'Admin',
        hidden: _ => !this.hasSimulationAccess(),
      },
      {
        id: 'planning',
        title: 'Planning',
        type: 'basic',
        link: '/rdvs',
        roles: 'Admin',
        hidden: _ => !this.isSicaUser(),
      },
      {
        id: 'map',
        title: 'Tournée',
        type: 'basic',
        link: '/map',
        roles: 'Admin',
        hidden: _ => !this.isACEPUser(),
      },

      {
        id: 'newsletters',
        title: 'Publications',
        type: 'basic',
        link: '/settings/newsletter',
        roles: 'Admin',
        hidden: _ => !this.isSicaUser(),
      },
      {
        id: 'partners',
        title: 'Financement',
        type: 'group',
        roles: 'Admin',
        hidden: _ => !this.isBothACEPSicaUser(),
        children: [
          {
            id: '1',
            title: 'Tableau de bord',
            type: 'basic',
            link: '/partners/dashboard',
            function: _ => this.executeActionBeforeLeavingCustomerDetails('/partners/dashboard'),
            //hidden: _ => !hasPermission('partners/dashboard')
          },
          {
            id: '2',
            title: 'Dossiers',
            type: 'basic',
            link: '/partners/drop-list',
            hidden: _ => !this.shouldShowClassicDossiers(),
            function: _ => this.executeActionBeforeLeavingCustomerDetails('/partners/drop-list'),
            //hidden: _ => !hasPermission('partners/drop-list')
          },
          {
            id: 'partners_project_folders_group',
            title: 'Dossiers',
            type: 'basic',
            link: '/partner-dossier-project',
            hidden: _ => !this.shouldShowProjectDossiers(),
            function: _ => this.executeActionBeforeLeavingCustomerDetails('/partner-dossier-project'),
            //hidden: _ => !hasPermission('partner-dossier-project')
          },
          {
            id: 'partners_project_legacy_group',
            title: 'Dossier Projet',
            type: 'basic',
            link: '/partner-dossier-project',
            hidden: _ => !this.isPartnerSpaceAdmin(),
            function: _ => this.executeActionBeforeLeavingCustomerDetails('/partner-dossier-project'),
            //hidden: _ => !hasPermission('partner-dossier-project')
          },
          {
            id: '3',
            title: 'Facturation',
            type: 'basic',
            link: '/partners/invoices',
            function: _ => this.executeActionBeforeLeavingCustomerDetails('/partners/invoices'),
            //hidden: _ => !hasPermission('partners/invoices')
          },
          {
            id: '4',
            title: 'Contrat',
            type: 'basic',
            link: '/partners/contracts',
            function: _ => this.executeActionBeforeLeavingCustomerDetails('/partners/contracts'),
            //hidden: _ => !hasPermission('partners/drop')
          },
        ]
      },
      {
        id: 'partners_dashboard',
        title: 'Accueil',
        type: 'basic',
        link: '/partners/dashboard',
        roles: 'Admin',
        hidden: _ => !this.isACEPUser() || this.isBothACEPSicaUser(),
      },
      {
        id: 'partners_foldrs',
        title: 'Dossiers',
        type: 'basic',
        link: '/partners/drop-list',
        roles: 'Admin',
        hidden: _ => !this.isACEPUser() || this.isBothACEPSicaUser() || !this.shouldShowClassicDossiers(),
      },
      {
        id: 'partners_project_folders',
        title: 'Dossiers',
        type: 'basic',
        link: '/partner-dossier-project',
        roles: 'Admin',
        hidden: _ => !this.isACEPUser() || this.isBothACEPSicaUser() || !this.shouldShowProjectDossiers(),
      },
      {
        id: 'partners_project_legacy',
        title: 'Dossier Projet',
        type: 'basic',
        link: '/partner-dossier-project',
        roles: 'Admin',
        hidden: _ => !this.isACEPUser() || this.isBothACEPSicaUser() || !this.isPartnerSpaceAdmin(),
      },
      {
        id: 'partners_invoices',
        title: 'Facturation',
        type: 'basic',
        link: '/partners/invoices',
        roles: 'Admin',
        hidden: _ => !this.isSicaUser(),
      },
      {
        id: 'partners_contracts',
        title: 'Contrats',
        type: 'basic',
        link: '/partners/contracts',
        roles: 'Admin',
        hidden: _ => !this.isSicaUser(),
      },
      {
        id: 'documentation',
        title: 'Documentation',
        type: 'group',
        roles: 'Admin',
        children: [
          {
            id: '1',
            title: 'FAQ / Guide',
            type: 'basic',
            link: '/settings/faq',
          },
          {
            id: '2',
            title: 'Newsletters',
            type: 'basic',
            link: '/settings/newsletter',
          },
        ]
      },
      {
        id: 'settings',
        title: 'Paramètres',
        type: 'basic',
        link: '/settings/landing',
        roles: 'Admin',
        hidden: _ => this.isAcepPartner || this.isMandataire,
        //hidden: _ => !isACEPUser() || (isACEPUser() && isSicaUser()),
      }
    ];
  }

  getHorizontalNavigation(): FuseNavigationItem[] {
    return [
      {
        id: 'dashboard',
        title: 'Accueil',
        type: 'basic',
        link: '/dashboard',
        roles: 'Admin',
        hidden: _ => !this.isSicaUser(),
        function: _ => this.executeActionBeforeLeavingCustomerDetails('/dashboard')
      },
      {
        id: 'prospects',
        title: 'Clients',
        type: 'basic',
        link: '/prospects',
        roles: 'Admin',
        hidden: _ => !this.isSicaUser(),
        function: _ => this.executeActionBeforeLeavingCustomerDetails('/prospects')
      },
      {
        id: 'simulation',
        title: 'Simulation',
        type: 'basic',
        link: '/simulator',
        roles: 'Admin',
        hidden: _ => !this.hasSimulationAccess(),
      },
      {
        id: 'planning',
        title: 'Planning',
        type: 'basic',
        link: '/rdvs',
        roles: 'Admin',
        hidden: _ => !this.isSicaUser(),
        function: _ => this.executeActionBeforeLeavingCustomerDetails('/rdvs')
      },
      {
        id: 'map',
        title: 'Tournée',
        type: 'basic',
        link: '/map',
        roles: 'Admin',
        hidden: _ => !this.isSicaUser(),
        function: _ => this.executeActionBeforeLeavingCustomerDetails('/map')
      },
      {
        id: 'partners',
        title: 'Financement',
        type: 'group',
        roles: 'Admin',
        hidden: _ => !this.isBothACEPSicaUser(),
        children: [
          {
            id: '1',
            title: 'Tableau de bord',
            type: 'basic',
            link: '/partners/dashboard',
            function: _ => this.executeActionBeforeLeavingCustomerDetails('/partners/dashboard'),
            //hidden: _ => !hasPermission('partners/dashboard')
          },
          {
            id: '2',
            title: 'Dossiers',
            type: 'basic',
            link: '/partners/drop-list',
            hidden: _ => !this.shouldShowClassicDossiers(),
            function: _ => this.executeActionBeforeLeavingCustomerDetails('/partners/drop-list'),
            //hidden: _ => !hasPermission('partners/drop-list')
          },
          {
            id: 'partners_project_folders_group',
            title: 'Dossiers',
            type: 'basic',
            link: '/partner-dossier-project',
            hidden: _ => !this.shouldShowProjectDossiers(),
            function: _ => this.executeActionBeforeLeavingCustomerDetails('/partner-dossier-project'),
            //hidden: _ => !hasPermission('partner-dossier-project')
          },
          {
            id: 'partners_project_legacy_group',
            title: 'Dossier Projet',
            type: 'basic',
            link: '/partner-dossier-project',
            hidden: _ => !this.isPartnerSpaceAdmin(),
            function: _ => this.executeActionBeforeLeavingCustomerDetails('/partner-dossier-project'),
            //hidden: _ => !hasPermission('partner-dossier-project')
          },
          {
            id: '3',
            title: 'Facturation',
            type: 'basic',
            link: '/partners/invoices',
            function: _ => this.executeActionBeforeLeavingCustomerDetails('/partners/invoices'),
            //hidden: _ => !hasPermission('partners/invoices')
          },
          {
            id: '4',
            title: 'Contrat',
            type: 'basic',
            link: '/partners/contracts',
            function: _ => this.executeActionBeforeLeavingCustomerDetails('/partners/contracts'),
            //hidden: _ => !hasPermission('partners/drop')
          },
        ]
      },
      {
        id: 'partners_dashboard',
        title: 'Accueil',
        type: 'basic',
        link: '/partners/dashboard',
        roles: 'Admin',
        hidden: _ => !this.isACEPUser() || this.isBothACEPSicaUser(),
      },
      {
        id: 'partners_foldrs',
        title: 'Dossiers',
        type: 'basic',
        link: '/partners/drop-list',
        roles: 'Admin',
        hidden: _ => !this.isACEPUser() || this.isBothACEPSicaUser() || !this.shouldShowClassicDossiers(),
      },
      {
        id: 'partners_project_folders',
        title: 'Dossiers',
        type: 'basic',
        link: '/partner-dossier-project',
        roles: 'Admin',
        hidden: _ => !this.isACEPUser() || this.isBothACEPSicaUser() || !this.shouldShowProjectDossiers(),
      },
      {
        id: 'partners_project_legacy',
        title: 'Dossier Projet',
        type: 'basic',
        link: '/partner-dossier-project',
        roles: 'Admin',
        hidden: _ => !this.isACEPUser() || this.isBothACEPSicaUser() || !this.isPartnerSpaceAdmin(),
      },
      {
        id: 'partners_invoices',
        title: 'Facturation',
        type: 'basic',
        link: '/partners/invoices',
        roles: 'Admin',
        hidden: _ => !this.isACEPUser() || this.isBothACEPSicaUser(),
      },
      {
        id: 'partners_contracts',
        title: 'Contrats',
        type: 'basic',
        link: '/partners/contracts',
        roles: 'Admin',
        hidden: _ => !this.isACEPUser() || this.isBothACEPSicaUser(),
      },
      {
        id: 'documentation',
        title: 'Documentation',
        type: 'group',
        roles: 'Admin',
        children: [
          {
            id: '1',
            title: 'FAQ / Guide',
            type: 'basic',
            link: '/settings/faq',
          },
          {
            id: '2',
            title: 'Newsletters',
            type: 'basic',
            link: '/settings/newsletter',
          },
        ]
      },
      {
        id: 'settings',
        title: 'Paramètres',
        type: 'basic',
        link: '/settings/landing',
        roles: 'Admin',
        hidden: _ => this.isAcepPartner || this.isMandataire,
        //hidden: _ =>!isACEPUser() && !isSicaUser(),
      },
    ];
  }
}
